import React from "react";
import DownArrow from "../../../../styles/images/down-arrow.png";
import Select, { components } from "react-select";


export default function UiSearchSelect(props) {
    const DropdownIndicator = (props) => {
        return (
            <components.DropdownIndicator {...props}>
                <img src={DownArrow} />
            </components.DropdownIndicator>
        );
    };
    const colorStyles = {
        placeholder: (defaultStyles) => {
            return {
                ...defaultStyles,
                color: "#B1B5C3",
            };
        },
    };
    return (

        <>
            <div className='sb-top-area-element'>
                {props.label &&
                    <label htmlFor={props.label}>{props.label}</label>
                }
                <Select
                    onChange={props.onChange}
                    className="basic-single"
                    classNamePrefix="select"
                    components={{ DropdownIndicator }}
                    styles={colorStyles}
                    placeholder={props.placeholder}
                    options={props.options}
                    value={props.value}

                />

            </div>
            {/* <Form.Control.Feedback type="invalid">
                                    {meta.error}
                                </Form.Control.Feedback> */}

        </>
    );



}


